<article [style.background-color]="backgroundColor" class="expanded-product-wrapper">
    <div *ngIf="productList.length > 0" class="product-items">
        <p *ngIf="expandedProductsHeading" class="font-weight-bold webkit-fill-available mb-sm-0 mb-2 ml-2">{{expandedProductsHeading}}</p>
        <ng-container *ngFor="let product of productList;">
            <div class="product-item cursor-pointer" (click)="onExpand(product)" [id]="expansionFor+product.name">
                <div class="product-name-box">
                    <span class="product-name">
                        {{product.name}}
                    </span>
                </div>
                <span *ngIf="(product.value).isNumber" class="product-value">
                    {{product.value | number: '1.0-2'}}
                </span>
                <span *ngIf="!(product.value).isNumber" class="product-value">
                    {{product.value}}
                </span>
                <div class="down-triangle" *ngIf="(selectedProduct === product.name) && (selectedProductVariant)">
                    <i class="fa fa-sort-up font-icon"></i>
                </div>
                <span class="view-less align-right" style="margin-left: auto">
                    <i [class]="selectedProduct === product.name ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                        aria-hidden="true"></i>
                </span>
            </div>
            <!-- <div class="down-triangle-wrapper" style="position: relative;">
                <div style="position: absolute;" class="down-triangle-abs" *ngIf="selectedProduct === product.name">
                    <i class="fa fa-sort-up font-icon"></i>
                </div>
            </div> -->
            <ng-container *ngIf="selectedProduct === product.name">
                <div style="width: -webkit-fill-available;" class="d-lg-none d-md-none d-sm-none  d-block" id="small-xstra-screen">
                    <ng-container *ngIf="selectedProduct">
                        <app-expanded-product-category 
                            (isCloseSubProductVariant)="handleProductVariantView($event)"
                            [selectedProductVariant]="selectedProductVariant" 
                            [selectedProduct]="selectedProduct"
                            [expansionFor]="expansionFor"
                            >
                        </app-expanded-product-category>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>


        <div style="width: -webkit-fill-available;" class="d-none d-lg-block d-md-block d-sm-block" id="medium-large-screen">
            <ng-container *ngIf="selectedProduct">
                <app-expanded-product-category 
                    (isCloseSubProductVariant)="handleProductVariantView($event)"
                    [selectedProductVariant]="selectedProductVariant"
                    [selectedProduct]="selectedProduct"
                    [expansionFor]="expansionFor"
                    >
                </app-expanded-product-category>
            </ng-container>
        </div>
    </div>
    <div *ngIf="productList.length < 1" class="no-data-available">
        <span>No Data found</span>
    </div>
    <div (click)="collapseExpanded(expansionFor)" class="expand-hide pr-5 pb-5">
        <span>Hide
            <i class="fa fa-angle-up" aria-hidden="true"></i>
        </span>
    </div>
</article>